/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Create_Account_MsgInputs */



/**
* | output |
* | --- |
* | "Create a new account to manage tournaments." |
*
* @param {Login_Create_Account_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_create_account_msg = /** @type {((inputs?: Login_Create_Account_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Create_Account_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez un nouveau compte pour gérer les tournois.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cree una nueva cuenta para gestionar torneos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Crie uma nova conta para gerenciar torneios.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un nuovo account per gestire tornei.")
	return /** @type {LocalizedString} */ ("Create a new account to manage tournaments.")
});